import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useLang } from "../LangContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsList() {
    const { t, lang } = useLang();
    const [items, setItems] = useState([]);

    useEffect(() => {
        axios.get(`${API}/news`).then((r) => setItems(r.data)).catch(() => {});
        window.scrollTo(0, 0);
    }, []);

    // Multilingual field picker with EN fallback (tolerates legacy plain strings)
    const pick = (f) => (f && typeof f === "object" ? (f[lang.toLowerCase()] || f.en || "") : f || "");

    return (
        <div className="bg-ink text-white grain min-h-screen" data-testid="news-list-page">
            <Header />
            <main className="pt-32 md:pt-40 px-6 md:px-12 pb-24">
                <div className="max-w-7xl mx-auto">
                    <span className="text-xs font-mono uppercase tracking-[0.3em] text-volt">— {t.news.label}</span>
                    <h1 className="font-graffiti text-5xl md:text-7xl text-white leading-[0.95] tracking-tight mt-4">
                        {t.news.title}
                    </h1>
                </div>

                <div className="max-w-7xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    {items.map((n) => (
                        <Link
                            key={n.id}
                            to={`/news/${n.slug}`}
                            className="bg-ink group flex flex-col hover:bg-inksurface transition-colors"
                        >
                            <div className="aspect-[16/10] w-full overflow-hidden bg-zinc-900">
                                {n.image_url ? (
                                    <img
                                        src={n.image_url}
                                        alt={pick(n.title)}
                                        className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                                    />
                                ) : null}
                            </div>
                            <div className="p-6 md:p-8 flex flex-col flex-1">
                                <div className="text-xs font-mono uppercase tracking-wider text-volt mb-3">{n.date}</div>
                                <h3 className="font-graffiti text-2xl md:text-3xl text-white leading-tight tracking-tight">
                                    {pick(n.title)}
                                </h3>
                                <p className="mt-4 text-sm text-zinc-400 leading-relaxed flex-1">{pick(n.excerpt)}</p>
                                <span className="mt-6 text-xs uppercase tracking-wider text-zinc-300 group-hover:text-volt inline-flex items-center gap-2">
                                    {t.news.read_more} <ArrowUpRight size={14} />
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
